require("es6-promise").polyfill();
import Vue from "vue";

import Vuex from "vuex";
Vue.use(Vuex);

import country_list from "./country_list.js";

// load global methods from external files
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

const localStorageValue = localStorage.getItem("user");
let userValue = {};
if (localStorageValue) {
  userValue = JSON.parse(window.atob(localStorage.getItem("user")));
}

const user = userValue;

const currencyLocalstorage = localStorage.getItem("currencyList");
let convertedCurrencies = {};
if (currencyLocalstorage) {
  convertedCurrencies = JSON.parse(window.atob(currencyLocalstorage));
}

const message = {
  info: "",
  msg: "",
  errors: [],
};

let countriesJsonForClient = {};

let countriesJsonForClient1 = localStorage.getItem("clientCountryJson");

if (countriesJsonForClient1) {
  countriesJsonForClient = JSON.parse(countriesJsonForClient1);
} else {
  countriesJsonForClient = country_list;
}

const loaders = {
  a: false,
  b: false,
  c: false,
};

const store = new Vuex.Store({
  state: {
    user,
    convertedCurrencies: convertedCurrencies,
    message,
    loaders,
    countriesJsonForClient: countriesJsonForClient,
  },
  actions,
  getters,
  mutations,
  modules: {},
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js